<div class="license ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-container">
    <div class="ya-dialog-content">
      <div class="container">
        <div class="license-container">
          <div class="license-icon">
            <div class="icon-container">
              <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-news"></div>
            </div>
          </div>
        </div>
        <div>
          <div ng-tns-c20-14 class="license-text-container">
            <h3 langkey="phLicense_Title"></h3>
          </div>
          <ng-container *ngFor="let license of licenses">
            <div class="license-outer-container">
              <div class="inline" *ngIf="license.name && license.name.trim() !== 'n/a'">
                <div langkey="phLicense_Name"></div>
                <div>: {{license.name}}</div>
              </div>
              <div class="inline" *ngIf="license.version && license.version.trim() !== 'n/a'">
                <div langkey="phLicense_Version"></div>
                <div>: {{license.version}}</div>
              </div>
              <div class="inline" *ngIf="license.license && license.license.trim() !== 'n/a'">
                <div langkey="phLicense_License"></div>
                <div>: {{license.license}}</div>
              </div>
              <div class="inline" *ngIf="license.link && license.link.trim() !== 'n/a'">
                <div langkey="phLicense_Repository_URL"></div>
                <div>
                  : <span class="clickable-link" (click)="setTargetNavigation(license.link)">
                    {{ getSafeRepositoryUrl(license.link) }}
                  </span>
                </div>
              </div>
              <div class="license-text-container">
                <button mat-stroked-button (click)="toggleLicense(license)" class="showmore">
                  <span *ngIf="!expandedLicenses.has(license)" langkey="phLicense_Showmore_Button"></span>
                  <span *ngIf="expandedLicenses.has(license)" langkey="phLicense_Showless_Button"></span>
                </button>

                <div *ngIf="expandedLicenses.has(license)" class="license-content">
                  <iframe [src]="getSanitizedLicenseUrl(getLicenseFileURL(license))" class="license-iframe"></iframe>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <div class="ya-button-container">
    <button mat-flat-button (click)="closeBottomSheet()">
      <span langkey="phLicense_Close_Button"></span>
    </button>
  </div>
</div>